import React, { useEffect } from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useLocation } from "react-router";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useHistory } from "react-router-dom";
import { headApi, credentials, convertToNextTenth } from "utils/headApi";
// import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
// import CardFooter from "components/Card/CardFooter.js";
// import CardAvatar from "components/Card/CardAvatar.js";
// import Info from "components/Typography/Info.js";
import Button from "components/CustomButtons/Button.js";
// import Favorite from "@material-ui/icons/Favorite";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Close from "@material-ui/icons/Close";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import Office from "assets/img/faces/3-tone-bangle-bracelet.jpg";
// import BanglesImage from "views/BanglesPage/Section/BanglesImage.js"

const useStyles = makeStyles(styles);
const useStyle = makeStyles(productStyle);
const useStyPop = makeStyles(javascriptStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function SearchList() {
  const [userList, setUserList] = React.useState([]);
  const [refundModal, setRefundModal] = React.useState(false);
  const [prodContact, setProdContact] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [notFound, setNotFound] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();
  const classPop = useStyPop();

  const { search } = useLocation();
  const category = new URLSearchParams(search).get("category");
  const state = new URLSearchParams(search).get("state");
  const catSize = new URLSearchParams(search).get("catSize");
  const country = new URLSearchParams(search).get("country");

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  async function getProdSEO() {
    const results = await fetch(
      headApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }
    );
    const res = await results.json();

    // console.log(res.map((f) => f.state));
    setStateList(res.map((f) => f.state))

    axios.get(headApi + `/admin/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      setCompanyList(res.data.AdminList.map((f) => f.company))
    });

    axios.get(headApi + `/category/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const items = res.data.map((f) => f.title);

      const uniqueItems = items.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );

      setCategoryList(uniqueItems);
    });

    axios.get(headApi + `/parent/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const itemss = res.data.map((f) => f.title);

      const uniqueItemss = itemss.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );
      setParentList(uniqueItemss);
    });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  useEffect(() => {
    // Define async function inside useEffect
    const getProd = async () => {
      try {
        const results = await fetch(`${headApi}/product/findByStateAndCategoryAndParent/${state}/${category}/${catSize}`, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });

        const res = await results.json();
        // console.log(res.products);

        if (!res.products || res.products.length === 0) {
          setNotFound("No products found! Redirecting to home..."); // simple message
          setTimeout(() => {
            history.push("/"); // redirect after 2 seconds
          }, 2000);
          return;
        }

        if (res.products && Array.isArray(res.products)) {
          // console.log(res.products);
          
          setUserList(res.products.filter((m) => m.active === true));

          // setUserList(res.products);
        }

      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        setLoading(false);
      }
    };

    getProd(); // Call async function
  }, [state, category, catSize]); // dependencies if these can change

  if (loading) return <p>Loading...</p>;

  return (
    <div className="cd-section" id="cards">
      <div>
        <Helmet>
          <title>B2B Search</title>
          <meta name="description" content="Best B2B Comapnay" />
          <meta
            name="keywords"
            content={`${categoryList},${parentList},${stateList},${companyList}`}
          />
          <meta name="keywords" content="Shaikh Imran" />
          {/*<meta name="keywords" content="Andhra Pradesh, Arunachal Pradesh, Assam, Bihar, Chhattisgarh, Goa, Gujarat, Haryana, Himachal Pradesh, Jharkhand, Karnataka, Kerala, Madhya Pradesh, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Odisha, Punjab, Rajasthan, Sikkim, Tamil Nadu, Telangana, Tripura, Uttar Pradesh, Uttarakhand, West Bengal" /> */}
        </Helmet>
        <div className={classes.container}>
          <h4 style={{ textAlign: "center", color: "red" }}>{notFound}</h4>
          <GridContainer>
            {userList &&
              userList.map((u) => (
                <GridItem sm={6} md={3} key={u.id}>
                  <Card product>
                    <CardHeader image>
                      <a
                        href={`/list?a=${u.adminId}&p=${u.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={u.image} alt="cardProduct2" />
                      </a>
                    </CardHeader>
                    <CardBody>
                      <h6
                        className={classNames(
                          classe.cardCategory,
                          classe.textRose
                        )}
                      >
                        {u.category + " - " + u.parent}
                      </h6>
                      <h4 className={classe.cardTitle} style={{ marginTop: "-15px" }}>
                        {/* <Button
                          simple
                          size="lg"
                          color="info"
                          onClick={() =>
                            history.push({
                              pathname: "/igs",
                              state: {
                                // location state
                                id: u,
                              },
                            })
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {u.company}
                        </Button> */}
                        <a
                          // href={`/igs?a=${u.id}`}
                          href={`/list?a=${u.adminId}&p=${u.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}&l=#aboutCompany`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {u.company}
                        </a>
                      </h4>
                      <div className={classe.cardDescription} style={{ marginTop: "-15px" }}>
                        {u.city + " " + u.state + " " + u.country}
                      </div>
                    </CardBody>
                    <CardFooter className={classe.justifyContentBetween} style={{ marginTop: "-30px" }}>
                      <div className={classe.price}>
                        {u.gstCash === true ? (
                          <>
                            <h5>
                              <span style={{ color: "red" }}>
                                Price ₹{" "}
                                {convertToNextTenth(u.taxInclude / u.box) + " Inc."}
                              </span>
                            </h5>
                          </>
                        ) : (
                          <>
                            <h5>
                              <span style={{ color: "black" }}>
                                Price ₹ {convertToNextTenth(u.cashPrice / u.box)}
                              </span>
                            </h5>
                          </>
                        )}
                      </div>
                    </CardFooter>
                    {/* <CardFooter className={classe.justifyContentBetween} style={{ marginTop: "-35px" }}> */}
                    <div className={classe.stats} style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "-40px",
                      marginBottom: "-10px"
                    }}>
                      <Tooltip
                        id="tooltip-top"
                        title="Click Here to Call"
                        placement="top"
                        classes={{ tooltip: classe.tooltip }}
                      >
                        <Button
                          simple
                          color="info"
                          size="lg"
                          href={`/list?a=${u.adminId}&p=${u.id}&category=${category}&catSize=${catSize}&country=${country}&state=${state}&l=#contactAreas`}
                          target="_blank"
                        // onClick={() => {
                        //   setRefundModal(true);
                        //   setProdContact(u);
                        // }}
                        >
                          contact
                        </Button>
                      </Tooltip>
                    </div>
                    {/* </CardFooter> */}
                  </Card>
                </GridItem>
              ))}
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6} lg={4}>
              {/* <Button block round onClick={() => setRefundModal(true)}>
              <LibraryBooks />
              Classic
            </Button> */}
              <Dialog
                classes={{
                  root: classPop.modalRoot,
                  paper: classPop.modal,
                }}
                open={refundModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setRefundModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
              >
                <DialogTitle
                  id="classic-modal-slide-title"
                  disableTypography
                  className={classPop.modalHeader}
                >
                  <Button
                    simple
                    className={classPop.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => setRefundModal(false)}
                  >
                    {" "}
                    <Close className={classPop.modalClose} />
                  </Button>
                  <h4 className={classPop.modalTitle}>{prodContact.company}</h4>
                </DialogTitle>
                <DialogContent
                  id="classic-modal-slide-description"
                  className={classPop.modalBody}
                >
                  <GridContainer>
                    <GridItem md={4}>
                      <img src="" />
                    </GridItem>
                    <GridItem md={8}>
                      <p>
                        Contact Seller and get details on your mobile quickly
                      </p>
                      <label>Mobile Number</label>
                      <PhoneInput
                        // style={mystyle}
                        inputStyle={{
                          width: "100%",
                          border: "none",
                          borderBottom: "1px solid #040000 ",
                          borderRadius: "0",
                        }}
                        country={"in"}
                        name="mobile"
                        value={mobile}
                        // onChange={(mobile) => handleMobileNumber(mobile)}
                        onChange={(mobile) => {
                          setMobile(mobile.length <= 12 ? mobile : mobile);
                        }}
                      />
                      <br />
                      <Button color="info">submit</Button>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions className={classPop.modalFooter}>
                  {/* <Button
                  onClick={() => setRefundModal(false)}
                  color="danger"
                  simple
                >
                  Close
                </Button> */}
                </DialogActions>
              </Dialog>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
